export const getAttributes = (el: Element | Node): Record<string, string> => {
  if (el instanceof Element) {
    const attrs = Array.from(el.attributes);
    return Object.assign({}, ...attrs.map((attr) => {
      return {
        [attr.name]: attr.value
      }
    }))
  }
  return {};
}
